import React from "react";

import "./Footer.css";

const getDate = new Date();
const year = getDate.getFullYear();
// const author = (
//   <div className="text-center">
//     <h5 id="email-link">By: <span className="font-weight-lighter">Nyawira Wanjiru&#8482; </span></h5>
//   </div>
// );
const screenWidth = window.screen.width;

const info = (
  <h5 className="font-weight-normal pt-1">Created with <span id="love">&#10084;</span>, React <small>(CRA)</small>, Bootstrap 4, CSS and Javascript<small>(optimized for mobile)</small>.</h5>
);

const detailsLarge = (
  <nav className="navbar col-12 footer navbar-expand-lg justify-content-between pt-0 mt-0 pb-0 mb-0">
    {info}
    <p className="pt-3 ">&copy;{year}</p>
  </nav>
);

const detailsSmall = (
  <nav className="navbar col-12 footer  pt-0 mt-0 pb-0 mb-0">
    {info}
    <p className="pt-3  mx-auto">&copy;{year}</p>
  </nav>
)

const Footer = () => {
  return (
    <div className="row d-flex mt-0 mb-0">
      {screenWidth < 750 ? detailsSmall : detailsLarge}
    </div>
  );
}

export default Footer;
